
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import NetatmoIcon from '~/components/NetatmoIcon.vue';
import Device from '~/components/Device/index.vue';
import DeviceData from '~/components/Data.vue';
import Operations from '~/components/Device/Operations.vue';
import { Device as IDevice } from '~/interfaces/device.interface';
import { DevicesModule } from '~/store/modules/devices';
import UserRightsMixin from '~/mixins/UserRightsMixin';

@Component({
    components: {
        NetatmoIcon,
        Device,
        DeviceData,
        Operations,
    },
})
export default class Module extends Mixins(UserRightsMixin) {
    @Prop() readonly id!: number;
    @Prop() readonly isSelected!: boolean;
    @Prop() readonly moduleData!: IDevice;

    orderedSpecFields = [];

    // watcher used to update data added with asynchronous call (such as getConfigs in NLG)
    @Watch('moduleData.orderedSpecFields', { deep: true, immediate: true })
    handler(orderedSpecFields: any) {
        this.orderedSpecFields = orderedSpecFields;
    }

    get currentGateway() {
        return DevicesModule.currentGateway;
    }

    get filteredOperations() {
        const currentModule = this.moduleData;
        const currentGateway = this.currentGateway;
        if (!currentModule || !currentGateway) {
            return [];
        }
        return currentModule.deviceOperations
            .filter((operation) => {
                return this.isAllowed(currentGateway.type, operation.action) && !operation.hidden;
            });
    }

    get showOperations() {
        return this.filteredOperations.length > 0;
    }
}
